import React, {Component} from 'react';
import { connect } from 'react-redux';
import {decodeSearchParams, getDefaultSearchParams, 
    getFormattedOptionsForReactSelect, getFormattedOptions, 
    getImageRoomTypes, /* getImageExteriorTypes,  */
    getFormattedValueForReactSelect, 
    GetSectionCustomizationOptions } from 'components/util';
import SelectBox from './select-box';
import '../css/select-box.css';
import Select from 'react-select';
//import Restblogo from '../img/logo_restb.png';
import HomeFeatures from 'components/homeFeatures';

//const SiteCustomizationOptions = GetSiteCustomizationOptions();
const SearchPageCustomizationOptions = GetSectionCustomizationOptions("SearchPageOptions");

class SearchTitleBar extends Component{

    constructor(props) {
        super(props);

        var defaultParameters = getDefaultSearchParams();
        var orderby = props.orderby || defaultParameters.orderby;
        var orderbydirection = props.orderbydirection || defaultParameters.orderbydirection;
        var imagetype = props.imagetype || defaultParameters.imagetype || "";
        var exteriorhomestyle = props.exteriorhomestyle || defaultParameters.exteriorhomestyle || "";
        var searchURLParams = props.searchURLParams;
        if(searchURLParams){
            searchURLParams = decodeSearchParams(searchURLParams);
            if(searchURLParams.orderby){
                orderby = searchURLParams.orderby;
            }
            if(searchURLParams.orderbydirection){
                orderbydirection = searchURLParams.orderbydirection;
            }
            if(searchURLParams.imagetype){
                imagetype = searchURLParams.imagetype;
            }
            if(searchURLParams.exteriorhomestyle){
                exteriorhomestyle = searchURLParams.exteriorhomestyle;
            }
        }
        else{
            var storedParams = window.sessionStorage.getItem("SearchParameters");
            if(storedParams){
                searchURLParams = Object.assign({}, JSON.parse(storedParams));
                if(searchURLParams.orderby){
                    orderby = searchURLParams.orderby;
                }
                if(searchURLParams.orderbydirection){
                    orderbydirection = searchURLParams.orderbydirection;
                }
                if(searchURLParams.imagetype){
                    imagetype = searchURLParams.imagetype;
                }
                if(searchURLParams.exteriorhomestyle){
                    exteriorhomestyle = searchURLParams.exteriorhomestyle;
                }
            }
        }
        var sortby = orderby + ":" + orderbydirection;

        this.state = {
            orderby: orderby,
            orderbydirection: orderbydirection,
            sortby: sortby,
            imagetype: imagetype,
            exteriorhomestyle: exteriorhomestyle
        };
        this.onChangeSort = this.onChangeSort.bind(this);
    }

    onChangeSort(val){
        /*const target = event.target;
        const value = target.value;

        if(value && value !== ""){
            if(this.refs.searchTitleBar) {
                var ob = value.split(':')[0];
                var obd = value.split(':')[1]
                this.setState({
                    sortby: value,
                    orderby: ob,
                    orderbydirection: obd
                });
                this.props.onChangeSort(ob,obd);
            }
        }*/

        if(val && val !== ""){
            if(this.refs.searchTitleBar) {
                var ob = val.split(':')[0];
                var obd = val.split(':')[1]
                this.setState({
                    sortby: val,
                    orderby: ob,
                    orderbydirection: obd
                });
                this.props.onChangeSort(ob,obd);
            }
        }
    }

    onChangeImageType = (val) => {
        /*const target = event.target;
        const value = target.value;
        //const text = target.options[target.selectedIndex].text;

        //if(value && value !== ""){
            if(this.refs.searchTitleBar) {
                var imgty = value;
                this.setState({
                    imagetype: imgty
                });
                this.props.onChangeImageType(imgty);
            }
        //}*/
        if(this.refs.searchTitleBar) {
            var imgty = "";
            if (val && ((Array.isArray(val) && val.length > 0) || (!Array.isArray(val) && val.value && val.value !== ""))) {
                if(Array.isArray(val)){
                    var aVal = "";
                    val.map(item => { if(aVal === ""){ aVal=item.value; } else{ aVal = aVal + "," + item.value; } return null;});
                    imgty = aVal;
                }
                else{
                    imgty = val.value;
                }
            }
            this.setState({
                imagetype: imgty,
                exteriorhomestyle: (imgty !== "exterior" ? "" : this.state.exteriorhomestyle)
            });
            this.props.onChangeImageType(imgty, (imgty !== "exterior" ? "" : this.state.exteriorhomestyle));
        }
    }

    onChangeExternalImageType = (val) => {
        if(this.refs.searchTitleBar) {
            var imgty = val;
            this.setState({
                exteriorhomestyle: imgty
            });
            this.props.onChangeImageType(this.state.imagetype, imgty);
        }
    }

    onChangeGridListView = () => {
        if(this.props.onChangeGridListView) {
            this.props.onChangeGridListView(this.props.showGrid);
        }
    }

    render() {

        /* let msg = (this.props.start) ? this.props.start : "";
        msg = (this.props.end) ? msg + " - " + this.props.end : "";
        msg = (this.props.total) ? msg + " of " + this.props.total + " Results" : "";
        if(this.props.pagesize && this.props.total && this.props.total <= this.props.pagesize){
            msg = this.props.total + " Results";
        } */

        var showImageSearch = true;
        if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.HideImageSearch){
            showImageSearch = false;
        }
        
        return (
            <div ref="searchTitleBar" className="col-sm-12 multi_sorting sorting_bg sort-by js-sort-by">
                <div className="fluid row">

                    

                    <div className={(this.state.imagetype && this.state.imagetype === "exterior") ? "exterior_value_select sorting_option" : "sorting_option"}>
                        
                        {/* !this.props.showMap &&
                            <span className="sorting_resultsnumber">{msg}</span>
                         */}
                        {/* this.props.showMap && this.props.wrapperClass && this.props.wrapperClass !== "" &&
                            <span className="sorting_resultsnumber">{msg}</span>
                         */}
                        {/* <div className="sorting_option_total hidden-xs hidden-sm visible-md">{this.props.total} Listings</div> */}

                        {/* <div className="search_map_checkbox">
                            <div  className="tru-checkbox-area mg-top-12">
                                <label className="tru-checkbox">
                                    <input type="checkbox" />
                                    <span className="tru-checkbox_checkmark"></span> 
                                </label>
                                <div className="tru-checkbok-name">Search Map</div>
                            </div>
                        </div> */}

                        <div className="tru-dropdown-square tru-dropdown-square-sort  low_high_dropdown small_dropdown mb_sort_dropdown">
                            <SelectBox
                                label="Sort By"
                                className="low_high_icon"
                                value={(this.state.sortby) ? this.state.sortby : "ListPrice:DESC"}
                                onChange={this.onChangeSort}>
                                <option value="newest:DESC">Newest</option>
                                {/* <option value="TLC:ASC">TLC(Low to High)</option> */}
                                <option value="TLC:ASC">TLC ↑</option>
                                {/* <option value="TLC:DESC">TLC(High to Low)</option> */}
                                <option value="TLC:DESC">TLC ↓</option>
                                <option value="BedroomsTotal:ASC">Bedrooms</option>
                                <option value="BathroomsTotalInteger:ASC">Bathrooms</option>
                                {/* <option value="ListPrice:ASC">Price(Low to High)</option> */}
                                <option value="ListPrice:ASC">Price ↑</option>
                                {/* <option value="ListPrice:DESC">Price(High to Low)</option> */}
                                <option value="ListPrice:DESC">Price ↓</option>
                                <option value="Garages:ASC">Lot area</option>
                                <option value="LivingArea:ASC">Square feet</option>
                            </SelectBox>
                        </div>

                        {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowGridviewListviewButtons) &&
                            <div className="listing_toggle hidden-xs">
                                {this.props.showGrid &&
                                    <div className="react-toggle-box" onClick={this.onChangeGridListView}>
                                        <div>
                                            <i className="fa fa-list-ul" />
                                        </div>
                                    </div>
                                }
                                {!this.props.showGrid &&
                                    <div className="react-toggle-box" onClick={this.onChangeGridListView}>
                                        <div>
                                            <i className="fa fa-th" />
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        
                        {showImageSearch &&
                        <div className="powered_by_box">
                            <div className={(this.state.imagetype && this.state.imagetype === "exterior") ? "tru-dropdown-square-sort image_tag_dropdown small_dropdown  mb_images_dropdown" : "tru-dropdown-square-sort image_tag_dropdown small_dropdown mb_images_dropdown"}>
                                {/* <SelectBox
                                    label="All Images"
                                    className="photo_icon image-item-category"
                                    value={(this.state.imagetype) ? this.state.imagetype : ""}
                                    onChange={this.onChangeImageType}>
                                    {getFormattedOptions([{value: "", text: "All Images"}].concat(getImageRoomTypes()))}
                                </SelectBox> */}
                                <div className="imagetype_list">
                                    <Select
                                        placeholder="All Images"
                                        name="imagetype"
                                        className="tru-dropdown-compact react-select-container image-item-category"
                                        classNamePrefix="react-select"
                                        onChange={(e) => this.onChangeImageType(e)}
                                        value={getFormattedValueForReactSelect([{value: "", text: "All Images"}].concat(getImageRoomTypes()), this.state.imagetype, false)}
                                        options={getFormattedOptionsForReactSelect([{value: "", text: "All Images"}].concat(getImageRoomTypes()))}
                                    />
                                </div>
                            </div>
                            {/*<div className="tru-dropdown-square tru-dropdown-square-sort mg-rt-5 small_dropdown">
                                <SelectBox
                                    label="Home Features"
                                    className="photo_icon image-item-category"
                                    value={(this.state.imagetype) ? this.state.imagetype : ""}
                                    onChange={this.onChangeImageType}>
                                    <option value="">Home Features</option>
                                    <option value="bathroom">Bathroom</option>
                                    <option value="bedroom">Bedroom</option>
                                    <option value="exterior">Exterior</option>
                                    <option value="kitchen">Kitchen</option>
                                    <option value="living,living_room">Living</option>
                                </SelectBox>
                            </div>*/}
                            {(this.state.imagetype && this.state.imagetype === "exterior") &&
                            <div className="tru-dropdown-square tru-dropdown-square-sort exterior_dropdown">
                                <SelectBox
                                    label="Exterior Style"
                                    value={(this.state.exteriorhomestyle) ? this.state.exteriorhomestyle : ""}
                                    onChange={this.onChangeExternalImageType}>
                                    {getFormattedOptions([{value: "", text: "Exterior Style"}].concat(this.props.exteriorstyles.map(e => { return {value: e, text: e} })))}
                                </SelectBox>
                            </div>
                            }
                            {/* <div className="restb_logo_box"><img src={Restblogo} alt="" /></div> */}
                            {<HomeFeatures features={this.props.features}></HomeFeatures>}
                            {/* <div className="features_list">
                                <Select
                                    placeholder="Home Features"
                                    name="homefeatures"
                                    className="tru-dropdown-compact react-select-container"
                                    classNamePrefix="react-select"
                                    isMulti={true}   
                                    options={homefeatureslisting}                                
                                />
                            </div> */}
                        </div>
                        }
                        
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    exteriorstyles: (state.listings && state.listings.exteriorstyle && state.listings.exteriorstyle.ids) ? state.listings.exteriorstyle.ids : []
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SearchTitleBar);